module.exports = __webpack_public_path__ + "static/media/en-US.6f382b2d.png";